import { useEffect, useState } from 'react';
import s from './MarketingModalOne.module.scss';
import { useTranslation } from 'react-i18next';
import { clearHTML } from 'utils/clearHTML';

export const MarketingModalOne = ({modal, lang}: any) => {

  // ### State
  const [show, setShow] = useState(true)
  const {i18n} = useTranslation()

  // ### Effects
  useEffect(()=>{
        if(modal){
            setInterval(() => {
                handleCheckModal(modal.interval, modal.active)
            }, 3000)
        }
    },[modal]);

    // ### Functions
    function handleCheckModal(interval: any, active: any){
        if(!active) return
        const modal = localStorage.getItem('modal')
        if(!modal){
            const newDate = new Date()
            newDate.setHours(newDate.getHours() + Number(interval))
            localStorage.setItem('modal', newDate.toISOString())
            setShow(true)
        }else{
            const now = new Date()
            const modalDate = new Date(modal)
            if(now > modalDate){
                setShow(true)
                now.setHours(now.getHours() + Number(interval))
                localStorage.setItem('modal', now.toISOString())
            }
        }
    }

  // ### Views
  console.log("123", modal);

  return(
      <div className={s.modal}>
        <img className={s.background} src={modal?.image[lang] || modal?.image[modal?.image?.default_image]} alt="background" />
        {
          modal?.is_button ? 
          <div className={s.button}>
              <span className={s.title}>{clearHTML(modal?.button_text[i18n.language])}</span>
          </div> : null
        }
      </div>
  )
}